<template>
    <simple-layout vertical>
        <basic-card>
            <template slot="header">
                Payments
            </template>
            <collapsible-content>
                <template slot="header">
                    Filter
                </template>
                <form-wrapper>
                    <form-select-input caption="Payment batch" v-model="paymentsFilter.batchId" :options="paymentBatchOptions"/>
                    <form-text-input caption="Due date" v-model="paymentsFilter.dueDate"/>
                    <form-select-input caption="Currency" v-model="paymentsFilter.currencyId" :options="currencyOptions"/>
                </form-wrapper>
                <simple-layout horizontal>
                    <empty/>
                    <empty/>
                    <simple-button @press="refreshData">Filter</simple-button>
                </simple-layout>
            </collapsible-content>
            <data-table
                :configuration="paymentsTableConfiguration"
                :data="payments"
                :pagination="paymentPagination"
                @pageChanged="handlePageChanged"
                component-id="payments-list"
            />
        </basic-card>
    </simple-layout>
</template>

<script>
    import SimpleLayout from "../components/layout/SimpleLayout";
    import BasicCard from "../components/layout/BasicCard";
    import {mapGetters} from "vuex";
    import DataTable from "../components/table/DataTable";
    import CollapsibleContent from "../components/CollapsibleContent";
    import FormWrapper from "../components/form/FormWrapper";
    import FormTextInput from "../components/form/FormTextInput";
    import FormSelectInput from "../components/form/FormSelectInput";
    import SimpleButton from "../components/button/SimpleButton";
    import Empty from "../components/layout/Empty";
    export default {
        name: "PaymentsView",
        components: {
            Empty,
            SimpleButton,
            FormSelectInput, FormTextInput, FormWrapper, CollapsibleContent, DataTable, BasicCard, SimpleLayout},
        data: function () {
            return {
                paymentsFilter: {

                },
                paymentsTableConfiguration: {
                    columns: [
                        {
                            caption: "Batch",
                            datum: d => this.paymentBatch(d.batchId) != null ? this.paymentBatch(d.batchId).displayName : "N/A"
                        },
                        {
                            caption: "ID",
                            datum: d => d.id
                        },
                        {
                            caption: "Counterparty",
                            datum: d => this.party(d.counterPartyId) != null ? this.party(d.counterPartyId).displayName : "N/A"
                        },
                        {
                            caption: "Amount",
                            datum: d => this.$formats.formatNumber(d.amount)
                        },
                        {
                            caption: "Currency",
                            datum: d => d.currencyId
                        },
                        {
                            caption: "Payment date",
                            datum: d => this.$formats.formatDate(d.dueDate)
                        },
                        {
                            caption: "Source account",
                            datum: d => this.account(d.sourceAccountId) != null ? this.account(d.sourceAccountId).name : "N/A"
                        },
                        {
                            caption: "Target account",
                            datum: d => this.account(d.targetAccountId) != null ? this.account(d.targetAccountId).name : "N/A"
                        }
                    ]
                }
            }
        },
        computed: {
            ... mapGetters({
                payments: "payments/payments",
                account: "banking/account",
                party: "parties/party",
                paymentBatch: "paymentBatches/paymentBatch",
                paymentBatches: "paymentBatches/paymentBatches",
                paymentPagination: "payments/paymentPagination",
                currencies: "currencies/currencies"
            }),
            currencyOptions() {
                return this.currencies.map(ccy => ({ id: ccy.code, name: ccy.code }))
            },
            paymentBatchOptions() {
                return this.paymentBatches.map(batch => ({ id: batch.id, name: batch.displayName }));
            },
            paymentsFilterAdjusted() {
                let result = {parameters: {}};
                Object.keys(this.paymentsFilter).forEach(key => {
                    if(typeof this.paymentsFilter[key] == 'undefined' ||
                        this.paymentsFilter[key] == null || this.paymentsFilter[key] == '') return;
                    result.parameters[key] = {
                        value: this.paymentsFilter[key],
                        operator: 'eq',
                        type: key == "dueDate" ? "date" : "string"

                    }
                })
                return result;
            }
        },
        methods: {
            refreshData(requestedPage) {
                return this.$store.dispatch("payments/refreshPaymentsPaged", {page: requestedPage, query: this.paymentsFilterAdjusted})
            },
            handlePageChanged(page) {
                this.refreshData(page);
            }
        },
        mounted() {
            this.refreshData();
        }
    }
</script>

<style lang="scss" scoped>

</style>